import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import searchIcon from "../../icons/searchIcon.svg"
import clearFilterImage from "../../../src/icons/clearFilter.svg"
import styled from "styled-components";
import { DataGrid, GridToolbarContainer } from "@mui/x-data-grid";

// responsive container styles
const isMobile = window.innerWidth < 900;
const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile &&
  `
    position: relative;
  `}
`;
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${isMobile ? "flex-start" : "space-between"};
  margin-bottom: 10px;
  flex-direction: ${isMobile ? "column" : "row"};
`;
const TableContainer = styled.div`
  width: 100%;
  border-radius: 8px;
`;
const DataGridContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
  height: 100%;
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
  display: ${isMobile ? "flex" : "grid"};
  ${isMobile && `flex-direction: column;`}
`;

export default function NotificationCentral() {
  const [loading, setLoading] = useState(false);
  const [userData] = useState(
    JSON.parse(localStorage.getItem("storedUserData")).user
  );
  const [accessChanges, setAccessChanges] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });
  const [openPopup, setOpenPopup] = useState(false);
  const [rsm, setRsm] = useState("");
  const [asm, setAsm] = useState("");
  const [rm, setRm] = useState("");
  const [rsms, setRsms] = useState([]);
  const [asms, setAsms] = useState([]);
  const [rms, setRms] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [hasSearched, setHasSearched] = useState(false);
  // Example dropdown data
  const [routes, setRoutes] = useState(["Route 101", "Route 202", "Route 303"]);
  const [clusters, setClusters] = useState(["Cluster A", "Cluster B"]);
  const [roles, setRoles] = useState(["Admin", "RSM", "ASM", "RM"]);

  const [selectedType, setSelectedType] = useState("all");

  const [sendType, setSendType] = useState("all");
  const [notificationTitle, setNotificationTitle] = useState("");
  const [notificationBody, setNotificationBody] = useState("");
  const [sessions, setSessions] = useState([]); // from API
  const [selectedSession, setSelectedSession] = useState("");
  const [isDateRangeDisabled, setIsDateRangeDisabled] = useState(false);
  const [isSessionDisabled, setIsSessionDisabled] = useState(false);
  const [accessModulesData, setAccessModulesData] = useState([]);
  const [filteredDate, setFilteredData] = useState({});

  useEffect(() => {
    fetchAccessModules();
    fetchSessions();
  }, []);

  const fetchSessions = async () => {
    try {
      setLoading(true);
      const response = await window.Platform.database.getAllSessions();
      // if (response?.data) {
      //   setSessions(response.data);
      // }
      if (response?.status) {
        const filterdData1 = response?.data?.filter((ele, ind) => ele?.action == "active")
        setFilteredData(filterdData1[0])
      }
      else {
        window.NotificationUtils.showError("Something Went Wrong in session")
      }
    } catch (error) {
      console.error("Error fetching sessions:", error);
      window.NotificationUtils.showError("Failed to load sessions");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (hasSearched) {
      fetchNotifications();
    }
  }, [paginationModel.page, paginationModel.pageSize]);

  useEffect(() => {
    if (!startDate && !endDate) {
      setIsSessionDisabled(false);
    }
  }, [startDate, endDate]);


  useEffect(() => {
    if (userData?.role.toLowerCase().includes("admin")) {
      getAllUsers();
    }
  }, []);

  useEffect(() => {
    getClusterInPicklist()
    fetchRoles()
  }, [])



  const fetchRoles = async (details) => {
    try {
      setLoading(true)
      let results = await window.Platform.database.fetchRoles(details);

      if (results?.status) {
        setLoading(false);
        window.NotificationUtils.showError("Something went wrong");
      }
      else {
        setRoles(results.data.map(ele => { return { name: ele?.name, id: ele?.roleName } }))
        setLoading(false)
      }
      // setProduct(results.data)
    }
    catch (err) {
      console.log(err);
      setLoading(false)

    }
  }

  const getClusterInPicklist = async () => {
    setLoading(true);
    try {
      let results = await window.Platform.database.getClusterInPicklist();

      const jsonArrayWithId = results?.data?.map((obj) => ({
        ...obj,
        dbId: obj.id
      }));


      setClusters(jsonArrayWithId);
      setLoading(false);
    } catch (error) {
      console.error("ERRORCHECK", error);
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    if (isNaN(date)) return ""; // safety check
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
    setNotificationTitle("");
    setNotificationBody("");
    setSendType("all");
    setSelectedValue("");
  };

  async function fetchNotifications() {
    setLoading(true);
    try {
      const payload = {
        pageNumber: paginationModel.page,
        recordPerPage: paginationModel.pageSize,
        ownerName: rm,
        rsm: userData?.role === "rsm" ? userData?.id : rsm,
        asm: userData?.role === "asm" ? userData?.id : asm,
        // startDate: startDate,
        // endDate: endDate,
        startDate: startDate != '' ? startDate : filteredDate?.startDate,
        endDate: endDate != '' ? endDate : filteredDate?.endDate,
        type: selectedType
      };
      const results = await window.Platform.database.fetchNotificationForWeb(
        payload
      );
      if (results) {
        const jsonArrayWithId = results?.data?.map((obj, index) => ({
          ...obj,
          id: index + 1,
        }));
        setAccessChanges(jsonArrayWithId);
        setRowCount(results?.data1);
      }
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Error fetching notifications");
    } finally {
      setLoading(false);
    }
  }

  async function getAllUsers() {
    const results = await window.Platform.database.fetchEmployees();
    setAllUsers(results?.data);
    setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() === "rsm"));
    setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() === "asm"));
    setRms(results?.data?.filter((ele) => ele.role.toLowerCase() === "se"));
  }

  async function getUsers(role, id) {
    setLoading(true);
    if (!id) {
      if (role === "rsm") {
        setAsm("");
        setRm("");
        setAsms(allUsers.filter((ele) => ele.role === "asm"));
        setRms(allUsers.filter((ele) => ele.role === "se"));
        setLoading(false);
      } else if (role === "asm") {
        setRm("");
        setRms(allUsers.filter((ele) => ele.role === "se"));
        setLoading(false);
      }
      return;
    }
    const results = await window.Platform.database.getUsersBasedOnManager({
      userId: id,
    });
    if (role === "rsm") {
      setAsms(results?.data);
      setRms(results?.data1);
      setLoading(false);
    }
    if (role === "asm") {
      setRms(results?.data);
      setLoading(false);
    }
  }

  // 💬 When “Send Notification” button is clicked
  const handleSendNotification = () => setOpenPopup(true);
  const handleCloseDialog = () => setOpenPopup(false);


  const handleSendSubmit = async () => {
    if (!notificationTitle.trim() || !notificationBody.trim()) {
      window.NotificationUtils.showWarning("Title and Body are required!");
      return;
    }
    if ((sendType != 'all' && !selectedValue)) {
      window.NotificationUtils.showWarning("Please Select the recepients");
      return;
    }
    try {
      const payload = {
        title: notificationTitle,
        body: notificationBody,
        type: sendType,
        target: selectedValue,
      };

      await window.Platform.database.sendNotification(payload);
      window.NotificationUtils.showSuccess("Notification sent successfully!");
      handleClosePopup();
      setOpenPopup(false);

      setSendType("all");
      fetchNotifications();
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Failed to send notification.");
    }
  };


  const clearFilters = async () => {
    setLoading(true);
    setRsm("");
    setAsm("");
    setRm("");
    setStartDate("");
    setEndDate("");
    setSelectedType("all")
    setIsDateRangeDisabled(false);
    setIsSessionDisabled(false);
    setSelectedSession("");
    setPaginationModel({ page: 0, pageSize: 20 });
    setRsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'rsm'));
    setRms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'se'));
    setAsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'asm'));
    setAccessChanges([]);
    setRowCount(0);
    setLoading(false);
    // try {
    //   let data = {
    //     pageNumber: 0,
    //     recordPerPage: 20,
    //     rsm: "",
    //     asm: "",
    //     ownerName: "",
    //     startDate: "",
    //     endDate: "",
    //   }
    //   let results = await window.Platform.database.fetchNotificationForWeb(data);
    //   if (results) {
    //     const jsonArrayWithId = results?.data?.map((obj, index) => ({
    //       ...obj,
    //       id: index + 1,
    //     }));
    //     setAccessChanges(jsonArrayWithId);
    //     setRowCount(results?.data1);
    //   }
    //   setLoading(false);
    // } catch (error) {
    //   console.error(error);
    //   window.NotificationUtils.showError("Error Fetching Data");
    //   setLoading(false);
    // }
    // finally {
    //   setLoading(false);
    // }
  }

  // function CustomToolbar() {
  //   return (
  //     <GridToolbarContainer className="d-flex justify-content-end align-items-center mr-2">
  //       <Typography
  //         variant="body1"
  //         sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}

  //       >
  //         Select Type:&nbsp;
  //       </Typography>
  //       <Select
  //         value={paginationModel.pageSize}
  //         size="small"
  //         onChange={(e) => {
  //           setPaginationModel({ ...paginationModel, pageSize: e.target.value }); setHasSearched(true);
  //         }}
  //         sx={{ fontSize: 14, fontWeight: 500 }}
  //       >
  //         {[10, 20, 30, 50, 100].map((size) => (
  //           <MenuItem key={size} value={size}>
  //             {size}
  //           </MenuItem>
  //         ))}
  //       </Select>

  //       <Typography
  //         variant="body1"
  //         sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}
  //       >
  //         Select Page Size:&nbsp;
  //       </Typography>
  //       <Select
  //         value={paginationModel.pageSize}
  //         size="small"
  //         onChange={(e) => {
  //           setPaginationModel({ ...paginationModel, pageSize: e.target.value }); setHasSearched(true);
  //         }}
  //         sx={{ fontSize: 14, fontWeight: 500 }}
  //       >
  //         {[10, 20, 30, 50, 100].map((size) => (
  //           <MenuItem key={size} value={size}>
  //             {size}
  //           </MenuItem>
  //         ))}
  //       </Select>
  //     </GridToolbarContainer>


  //   );
  // }

  const fetchAccessModules = async () => {
    try {
      setLoading(true);
      let data = {
        pageNumber: paginationModel.page,
        recordPerPage: paginationModel.pageSize,
        userId: userData?.id,
        moduleId: "1iK1ZCnTrL"
      }
      let results = await window.Platform.database.fetchAccessModules(data);
      if (results?.status) {
        window.NotificationUtils.showError(results?.message || "Something went wrong");
        setLoading(false);
        return;
      }
      else {
        const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
        setAccessModulesData(jsonArrayWithId);
      }
    } catch (error) {
      console.error(error);
    }
    finally {
      setLoading(false)
    }
  }

  function CustomToolbar() {
    return (
      <GridToolbarContainer
        className="d-flex justify-content-between align-items-center px-3"
      >
        {/* Left side - Select Type */}
        <div className="d-flex align-items-center">
          <Typography
            variant="body1"
            sx={{ color: "black", fontSize: "14px", fontWeight: "500", mr: 1 }}
          >
            Select Type :
          </Typography>

          <FormControl size="small" sx={{ minWidth: 180 }}>
            <InputLabel id="select-type-label">Choose Type</InputLabel>
            <Select
              labelId="select-type-label"
              value={selectedType}
              label="Choose Type"
              onChange={(e) => setSelectedType(e.target.value)}
              sx={{
                fontSize: 14,
                fontWeight: 500,
                borderRadius: "12px",
                backgroundColor: "#f8f9fa",
              }}
            >
              {/* Common Options */}
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="Attendance">Attendance</MenuItem>
              <MenuItem value="allowance">Allowance</MenuItem>
              <MenuItem value="Auto Punch Out">Auto Punch Out</MenuItem>
              <MenuItem value="Base Location">Base Location</MenuItem>
              <MenuItem value="expense">Expense</MenuItem>
              <MenuItem value="Leave Request">Leave Request</MenuItem>
              <MenuItem value="order">Order</MenuItem>
              <MenuItem value="otp">OTP</MenuItem>
              <MenuItem value="Party Location">Party Location</MenuItem>
              <MenuItem value="Route Plan">Route Plan</MenuItem>
              <MenuItem value="specimen">Specimen</MenuItem>
              <MenuItem value="User Request">User Request</MenuItem>
              <MenuItem value="visit">Visit</MenuItem>
              <MenuItem value="olympiad">Olympiad</MenuItem>
            </Select>
          </FormControl>
        </div>

        {/* Right side - Select Page Size */}
        <div className="d-flex align-items-center">
          <Typography
            variant="body1"
            sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}
          >
            Select Page Size:&nbsp;
          </Typography>
          <Select
            value={paginationModel.pageSize}
            size="small"
            onChange={(e) => {
              setPaginationModel({
                ...paginationModel,
                pageSize: e.target.value,
              });
              setHasSearched(true);
            }}
            sx={{ fontSize: 14, fontWeight: 500, minWidth: 100 }}
          >
            {[10, 20, 30, 50, 100].map((size) => (
              <MenuItem key={size} value={size}>
                {size}
              </MenuItem>
            ))}
          </Select>
        </div>
      </GridToolbarContainer>
    );
  }


  const renderContent = () => (
    <DataGridContainer style={{ height: !accessChanges?.length ? '200px' : 'auto' }}>
      <DataGrid
        rowHeight={60}
        disableDensitySelector
        disableSelectionOnClick
        disableRowSelectionOnClick
        className="payrollGrid"
        density="compact"
        rows={accessChanges || []}
        // columns={[
        //   { field: "name", headerName: "Name", width: 160 },
        //   { field: "header", headerName: "Title", width: 250 },
        //   { field: "body", headerName: "Message", width: 500 },
        //   { field: "createAt", headerName: "Created At", width: 180 },
        // ]}
        columns={[
          { field: "name", headerName: "Name", width: 200 },
          { field: "header", headerName: "Title", width: 250 },
          { field: "body", headerName: "Message", width: 500 },
          {
            field: "createAt",
            headerName: "Created At",
            width: 210,
            valueGetter: (params) => {
              if (!params.value) return "";
              const date = new Date(params.value);
              // Convert to IST
              return date.toLocaleString("en-IN", {
                timeZone: "Asia/Kolkata",
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
              });
            },
          },
        ]}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        sx={{ color: "black", fontSize: "13px", fontWeight: 500 }}
        rowCount={rowCount}
        paginationModel={paginationModel}
        paginationMode="server"
        onPaginationModelChange={setPaginationModel}
        components={{ Toolbar: CustomToolbar }}
      />
    </DataGridContainer>
  );

  return (
    <>
      <StaffEditorPageContainer>
        <HeaderContainer>
          {loading && <OpaqueLoading />}
          <Box sx={{ mt: 2, width: "100%" }}>
            <Paper
              elevation={4}
              sx={{
                p: 3,
                mb: 3,
                borderRadius: 3,
                background:
                  "linear-gradient(135deg, #e3ecff 0%, #f7faff 100%)",
              }}
            >
              <div className="container-fluid">
                <div className="row">
                  {userData?.role.includes("admin") && (
                    <div className="col-md-4">
                      <FormControl fullWidth size="small">
                        <InputLabel sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}>Select HO</InputLabel>
                        <Select
                          label="Select HO"
                          value={rsm}
                          sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                          onChange={(e) => {
                            setRsm(e.target.value);
                            getUsers("rsm", e.target.value);
                            setAsm("");
                            setRm("");
                          }}
                        >
                          <MenuItem value="" sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}>All</MenuItem>
                          {rsms.map((role) => (
                            <MenuItem key={role.id} value={role.id} sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}>
                              {role.name} - {role.username}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  )}

                  {userData?.role !== "asm" && (
                    <div className="col-md-4">
                      <FormControl fullWidth size="small">
                        <InputLabel sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}>Select ARM</InputLabel>
                        <Select
                          label="Select ARM"
                          value={asm}
                          sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                          onChange={(e) => {
                            setAsm(e.target.value);
                            getUsers("asm", e.target.value);
                            setRm("");
                          }}
                        >
                          <MenuItem value="" sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}>All</MenuItem>
                          {asms.map((role) => (
                            <MenuItem key={role.id} value={role.id} sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}>
                              {role.name} - {role.username}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  )}

                  <div className="col-md-4">
                    <FormControl fullWidth size="small">
                      <InputLabel sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}>Select RM</InputLabel>
                      <Select
                        label="Select RM"
                        value={rm}
                        sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                        onChange={(e) => {
                          setRm(e.target.value);
                        }}
                      >
                        <MenuItem value="" sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}>All</MenuItem>
                        {rms.map((role) => (
                          <MenuItem key={role.id} value={role.id} sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}>
                            {role.name} - {role.username}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-4">
                    <TextField
                      InputLabelProps={{
                        shrink: true,
                        style: { color: "black", fontSize: "14px", fontWeight: 500 },
                      }}
                      inputProps={{
                        style: { color: "black", fontSize: "14px", fontWeight: 500 },
                      }}
                      fullWidth
                      label="From Date"
                      size="small"
                      type="date"
                      value={startDate}
                      disabled={isDateRangeDisabled}
                      onChange={(e) => {
                        const value = e.target.value;
                        setStartDate(value);
                        if (value) {
                          setIsSessionDisabled(true);
                          setSelectedSession("");
                        } else if (!value && !endDate) {
                          setIsSessionDisabled(false);
                        }
                      }}
                    />
                  </div>
                  <div className="col-md-4">
                    <TextField
                      InputLabelProps={{
                        shrink: true,
                        style: { color: "#000", fontSize: "14px", fontWeight: 500 },
                      }}
                      inputProps={{
                        style: { color: "#000", fontSize: "14px", fontWeight: 500 },
                      }}
                      fullWidth
                      label="To Date"
                      size="small"
                      type="date"
                      value={endDate}
                      disabled={isDateRangeDisabled}
                      onChange={(e) => {
                        const value = e.target.value;
                        setEndDate(value);
                        if (value) {
                          setIsSessionDisabled(true);
                          setSelectedSession("");
                        } else if (!value && !startDate) {
                          setIsSessionDisabled(false);
                        }
                      }}
                    />
                  </div>
                  <div className="col-md-2">
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />}
                      color="primary"
                      fullWidth
                      sx={{ fontSize: "14px", borderRadius: "10px" }}
                      onClick={() => {
                        setHasSearched(true);
                        fetchNotifications();
                      }}
                    >
                      Find
                    </Button>
                  </div>
                  <div className="col-md-2">
                    <Button
                      variant="contained"
                      startIcon={<img src={clearFilterImage} alt="icon" height={"21"} width={"21"} />}
                      color="secondary"
                      size="small"
                      fullWidth
                      sx={{ fontSize: "14px", borderRadius: "10px" }}
                      onClick={() => clearFilters()}
                    >
                      Clear Filters
                    </Button>
                  </div>
                </div>

                {/* 🎓 Session Dropdown */}
                <div className="row mt-2">
                  {/* <div className="col-md-4">
                    <FormControl fullWidth size="small">
                      <InputLabel
                        sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                      >
                        Select Session
                      </InputLabel>
                      <Select
                        label="Select Session"
                        value={selectedSession}
                        disabled={isSessionDisabled}
                        sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                        onChange={(e) => {
                          const selected = sessions.find((item) => item.id === e.target.value);
                          setSelectedSession(e.target.value);

                          if (selected) {
                            // ✅ Convert UTC → IST (local date)
                            const start = new Date(selected.startDate);
                            const end = new Date(selected.endDate);

                            const startIST = new Date(start.getTime() + (5.5 * 60 * 60 * 1000))
                              .toISOString()
                              .split("T")[0];
                            const endIST = new Date(end.getTime() + (5.5 * 60 * 60 * 1000))
                              .toISOString()
                              .split("T")[0];

                            setStartDate(startIST);
                            setEndDate(endIST);

                            // ✅ Disable manual date range if session chosen
                            setIsDateRangeDisabled(true);
                          } else {
                            // ✅ If cleared, re-enable date inputs
                            setIsDateRangeDisabled(false);
                          }
                        }}

                      >
                        <MenuItem value="">
                          <em>Select Session</em>
                        </MenuItem>
                        {sessions.map((s) => (
                          <MenuItem key={s.id} value={s.id}>
                            {s.sessionName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div> */}
                </div>


              </div>

            </Paper>
            {/* Send Notification Button */}
            {/* <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                      <Button
                        variant="contained"
                        size="large"
                        onClick={handleSendNotification}
                        sx={{
                          textTransform: "none",
                          fontSize: 16,
                          fontWeight: 600,
                          borderRadius: 2,
                          px: 4,
                          py: 1,
                          background:
                            "linear-gradient(90deg, #2563eb 0%, #1e40af 100%)",
                          boxShadow: "0 4px 14px rgba(37,99,235,0.3)",
                          "&:hover": {
                            background:
                              "linear-gradient(90deg, #1d4ed8 0%, #1e3a8a 100%)",
                          },
                        }}
                      >
                        🚀 Send Notification
                      </Button>
                    </Box> */}
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  px: 2,
                  py: 1,
                  background: "#e8f5e9",
                  border: "1px solid #a5d6a7",
                  borderLeft: "4px solid #2e7d32",
                  borderRadius: "8px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                  width: "fit-content",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#1b5e20",
                    letterSpacing: "0.3px",
                  }}
                >
                  Total Entries:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 700,
                    color: "#2e7d32",
                    background: "#fff",
                    px: 1.2,
                    py: 0.2,
                    borderRadius: "6px",
                    border: "1px solid #a5d6a7",
                    minWidth: "28px",
                    textAlign: "center",
                  }}
                >
                  {accessChanges?.length > 0 ? rowCount : 0 || 0}
                </Typography>
              </Box>
              {accessModulesData && accessModulesData[0]?.is_add?.toLowerCase() != "no" && userData && userData?.role?.includes("admin") &&
                <Box>
                  <Button
                    variant="contained"
                    size="large"
                    onClick={handleSendNotification}
                    sx={{
                      textTransform: "none",
                      fontSize: 18,
                      fontWeight: 700,
                      letterSpacing: 0.5,
                      borderRadius: 2,
                      px: 4,
                      // py: 1,
                      background: "linear-gradient(90deg, #2563eb 0%, #1e40af 100%)",
                      boxShadow: "0 4px 14px rgba(37,99,235,0.3)",
                      //   "&:hover": {
                      //     background: "linear-gradient(90deg, #1d4ed8 0%, #1e3a8a 100%)",
                      //     transform: "scale(1.05)",
                      //   },
                      //   transition: "all 0.2s ease-in-out",
                      // }}
                      color: "white",
                      fontFamily: `'Poppins', sans-serif`,
                      background: "linear-gradient(90deg, #16a34a 0%, #15803d 100%)", // ✅ green gradient
                      boxShadow: "0 4px 14px rgba(22,163,74,0.3)", // ✅ subtle green glow
                      "&:hover": {
                        background: "linear-gradient(90deg, #15803d 0%, #166534 100%)", // darker green hover
                        transform: "scale(1.05)",
                        boxShadow: "0 6px 18px rgba(3, 211, 79, 0.4)",
                      },
                      transition: "all 0.2s ease-in-out",
                    }}
                  >
                    🚀 <span style={{ marginLeft: 8 }}>Send Notification</span>
                  </Button>
                </Box>}
            </Box>

          </Box>
        </HeaderContainer>

        <TableContainer>{renderContent()}</TableContainer>
      </StaffEditorPageContainer>

      <Dialog
        open={openPopup}
        onClose={handleClosePopup}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            fontWeight: 600,
            color: "#1e3a8a",
          }}
        >
          Create New Notification
        </DialogTitle>

        <DialogContent dividers>
          <TextField
            fullWidth
            label="Notification Title"
            variant="outlined"
            value={notificationTitle}
            onChange={(e) => setNotificationTitle(e.target.value)}
            sx={{ mb: 2 }}
          />

          <TextField
            fullWidth
            label="Notification Body"
            variant="outlined"
            multiline
            rows={3}
            value={notificationBody}
            onChange={(e) => setNotificationBody(e.target.value)}
            sx={{ mb: 3 }}
          />

          <Typography sx={{ mb: 1, fontWeight: 500 }}>
            Send To:
          </Typography>

          <RadioGroup
            row
            value={sendType}
            onChange={(e) => {
              setSendType(e.target.value);
              setSelectedValue("");
            }}
            sx={{ mb: 2 }}
          >
            <FormControlLabel value="all" control={<Radio />} label="All" />

            <FormControlLabel
              value="cluster"
              control={<Radio />}
              label="Cluster Wise"
            />
            <FormControlLabel
              value="role"
              control={<Radio />}
              label="Role Wise"
            />
          </RadioGroup>

          {/* Dynamic Dropdown based on Selection */}
          {sendType !== "all" && (
            <FormControl fullWidth size="small">
              <InputLabel>
                {sendType === "cluster"
                  ? "Select Cluster"
                  : "Select Role"}
              </InputLabel>
              <Select
                value={selectedValue}
                onChange={(e) => setSelectedValue(e.target.value)}
                label={
                  sendType === "cluster"
                    ? "Select Cluster"
                    : "Select Role"
                }
              >
                {(sendType === "cluster"
                  ? clusters
                  : roles
                ).map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClosePopup}>Cancel</Button>
          <Button
            onClick={handleSendSubmit}
            variant="contained"
            sx={{
              background:
                "linear-gradient(90deg, #2563eb 0%, #1e40af 100%)",
              "&:hover": {
                background:
                  "linear-gradient(90deg, #1d4ed8 0%, #1e3a8a 100%)",
              },
            }}
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
